import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "../action/loginSlice"
import getAllProductListSlice from "../action/getAllProductSlice"
import getAllUserListSlice from "../action/getAllUserListSlice"
import getUserDetailsSlice from "../action/getUserDetailsSlice"
import getAllGroupsSlice from "../action/getAllGroups"
import getAllGroupsMembersSlice from "../action/getGroupsMembers"
import getAllProductsInGroupsSlice from "../action/getAllProductsInGroups"
import addProductSlice from "../action/addProductSlice"
import getProductFeaturesSlice from "../action/getproductFeaturesSlice"
import addProductFeaturesSlice from "../action/addProductFeaturesSlice"
import getProductFeatureContentSlice from "../action/getProductFeatureContentSlice"
import fileUploadSlice from "../action/fileUpload"
import updateProduct from "../action/updateProduct-Slice"
import getAllStatesSlice from "../action/getAllStates"
import getGroupProductFeatures from "../action/getGroupProductFeature"
import updateGroupProductFeatures from "../action/updateGroupProductFeature"
import getGroupProductFeatureContent from "../action/getGroupProductFeatureContent"
import addNotificationDetailsDetails from "../action/addNotificationsSlice"
import updateNotificationsDetails from "../action/updateNotificationsSlice"
import getNotificationsListSlice from "../action/getNotificationsListSlice";
import deleteNotification from "../action/deleteNotification";
import reportsList from "../action/reportsSlice"
import welcomeEmailListData from "../action/welcomeEmailList"
import triggerWelcomeData from "../action/triggerWelcomeEmail"
import productListDropdownSlice from "../action/productListDropdownAPI"
import userListDropdownSlice from "../action/userListDropdownAPI"
import groupListDropdownSlice from "../action/groupListDropdownAPI"
import welcomeEmailTemplateListData from "../action/welcomeEmailTemplateList"
import createEmailTemplateSlice from "../action/createEmailTemplate"
import updateEmailTemplateSlice from "../action/updateEmailTemplate"
import claimReminderTemplateListSlice from "../action/claimReminderTemplates"
import analyticsSlice from "../action/analyticsSlice"
import getReleaseDocsSlice from "../action/getReleaseDocs"
import createOrUpdateReleaseDocSlice from "../action/createOrUpdateReleaseDoc"
import appDownloadSlice from "../action/appDownloadSlice"
import getAllAiCampaignsSlice from "../action/getAllAiCampaignsSlice"
import createAiCampaignSlice from "../action/createAiCampaignSlice"
import getAiCampaignDetailsSlice from "../action/getAiCampaignDetailsSlice"
import updateAiCampaignStatusSlice from "../action/updateAiCampaignStatusSlice"
import updateAiCampaignSlice from "../action/updateAiCampaignSlice"
import getAiCampaignMembersSlice from "../action/getAiCampaignMembersSlice"
import getMemberActionStatusesSlice from "../action/getMemberActionStatusesSlice"
import exportAiCampaignResultsSlice from "../action/exportAiCampaignResultsSlice"
import restartAiCampaignSlice from "../action/restartAiCampaignSlice"
import downloadAiCampaignSampleCsvSlice from "../action/downloadAiCampaignSampleCsvSlice"
import createMaterialSlice from "../action/createMaterialSlice"
import getAllMaterialSlice from "../action/getAllMaterialSlice"
import getMaterialDetailsSlice from "../action/getMaterialDetailsSlice"
import getEnrollmentAgreementListSlice from "../action/getEnrollmentAgreementListSlice"
import updateEnrollmentAgreementSlice from "../action/updateEnrollmentAgreementSlice"
import getEnrollmentAgreementDetailsSlice from "../action/getEnrollmentAgreementDetailsSlice"
import updateEnrollmentAgreementStatusSlice from "../action/updateEnrollmentAgreementStatusSlice"
import getTermsAndConditionsListSlice from "../action/getTermsAndConditionsListSlice"
import updateTermsAndConditionsStatusSlice from "../action/updateTermsAndConditionsStatusSlice"
import getTermsAndConditionsDetailsSlice from "../action/getTermsAndConditionsDetailsSlice"
import updateTermsAndConditionsSlice from "../action/updateTermsAndConditionsSlice"
import deleteFileSlice from "../action/deleteFileSlice"

const store = configureStore({
    reducer: {
        loginSliceDetails: loginSlice,
        getAllProductList: getAllProductListSlice,
        getAllUserList: getAllUserListSlice,
        getUserDetails: getUserDetailsSlice,
        getAllGroups: getAllGroupsSlice,
        getAllGroupsMemberList: getAllGroupsMembersSlice,
        getAllProductInGroupsList: getAllProductsInGroupsSlice,
        addProductDetails: addProductSlice,
        getProductFeatures: getProductFeaturesSlice,
        addProductFeatures: addProductFeaturesSlice,
        getProductFeatureContentMain: getProductFeatureContentSlice,
        fileUploadData: fileUploadSlice,
        updateProductSlice: updateProduct,
        getAllStates: getAllStatesSlice,
        getGroupProductFeatureState: getGroupProductFeatures,
        updateGroupProductFeatureMain: updateGroupProductFeatures,
        getGroupProductFeatureContent: getGroupProductFeatureContent,
        notificationSliceDetails: addNotificationDetailsDetails,
        updateNotificationsSlice: updateNotificationsDetails,
        getNotificationsListDetails: getNotificationsListSlice,
        deleteNotificationSlice: deleteNotification,
        reportsListDetails:reportsList,
        welcomeEmailList:welcomeEmailListData,
        triggerWelcome:triggerWelcomeData,
        productListDropdown:productListDropdownSlice,
        userListDropdown:userListDropdownSlice,
        groupListDropdown:groupListDropdownSlice,
        welcomeEmailTemplateList:welcomeEmailTemplateListData,
        createEmailTemplate:createEmailTemplateSlice,
        updateEmailTemplate:updateEmailTemplateSlice,
        getClaimReminderTemplates:claimReminderTemplateListSlice,
        analyticsDetails:analyticsSlice,
        getReleaseDocs:getReleaseDocsSlice,
        createOrUpdateReleaseDoc:createOrUpdateReleaseDocSlice,
        appDownloadDetails:appDownloadSlice,
        getAllAiCampaigns: getAllAiCampaignsSlice,
        createAiCampaign: createAiCampaignSlice,
        getAiCampaignDetails: getAiCampaignDetailsSlice,
        updateAiCampaignStatus: updateAiCampaignStatusSlice,
        updateAiCampaign: updateAiCampaignSlice,
        getAiCampaignMembers: getAiCampaignMembersSlice,
        getMemberActionStatuses: getMemberActionStatusesSlice,
        exportAiCampaignResults: exportAiCampaignResultsSlice,
        restartAiCampaign: restartAiCampaignSlice,
        downloadAiCampaignSampleCsv: downloadAiCampaignSampleCsvSlice,
        createMaterial: createMaterialSlice,
        getAllMaterial: getAllMaterialSlice,
        getMaterialDetails: getMaterialDetailsSlice,
        getEnrollmentAgreementList: getEnrollmentAgreementListSlice,
        updateEnrollmentAgreement: updateEnrollmentAgreementSlice,
        getEnrollmentAgreementDetails: getEnrollmentAgreementDetailsSlice,
        updateEnrollmentAgreementStatus: updateEnrollmentAgreementStatusSlice,
        getTermsAndConditionsList: getTermsAndConditionsListSlice,
        updateTermsAndConditionsStatus: updateTermsAndConditionsStatusSlice,
        getTermsAndConditionsDetails: getTermsAndConditionsDetailsSlice,
        updateTermsAndConditions: updateTermsAndConditionsSlice,
        deleteFile: deleteFileSlice,
    },
});

export default store;
